<template>
	<div>
		<v-toolbar
			color="secondary"
			dark
			tabs
			class="toolbar"
			height="100px"
		>
			<div class="toolbar-image-container">
				<div
					:style="bgImgStyle"
					class="toolbar-image"
				/>
			</div>
			<v-container
				v-if="!loading"
				py-o
				my-0
				class="toolbar-title"
			>
				<v-toolbar-title class="display-2 ma-0">
					<slot name="title" />
				</v-toolbar-title>
				<slot name="breadcrumbs">
					<v-breadcrumbs
						:items="breadcrumbs"
						class="pt-1"
					/>
				</slot>
			</v-container>
			<v-tabs
				v-show="!loading && routes.length > 0"
				slot="extension"
				centered
				color="rgba(0,0,0,0)"
			>
				<v-tab
					v-for="route in routes"
					:key="route.name"
					:to="route.to"
				>
					<svg v-if="route.highlight" height="10" width="12">
						<circle cx="5" cy="5" r="3" :fill="$vuetify.theme.error" />
					</svg>
					{{ route.name }}
				</v-tab>
			</v-tabs>
			<v-btn
				absolute
				dark
				fab
				bottom
				right
				small
				:href="helpLink"
				target="_blank"
				color="grey"
			>
				<!-- Potentially use this to emulate old version of help
				popup router-views also have slot help -->
				<!-- @click="$emit('help')" -->
				<v-icon>fa fa-question</v-icon>
			</v-btn>
			<div v-if="!loading" class="toolbar-additional">
				<slot name="additional" />
			</div>
		</v-toolbar>
		<loading :loading="loading" />
		<slot v-if="!loading" />
	</div>
</template>

<script>
// Exposes 3 slots: default, title and additional
export default {
	props: {
		loading: { type: Boolean, default: false },
		image: { type: String, default: undefined },
		routes: { type: Array, default: () => [] },
		breadcrumbs: { type: Array, default: () => [] },
		routeTitle: { type: String, default: undefined },
	},
	data() {
		return {
			helpLink: 'https://support.reportmule.com/en',
		};
	},
	computed: {
		bgImgStyle() {
			if (!this.image) {
				return '';
			}
			return `background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.3) ), url(${this.image})`;
		},
	},
	watch: {
		$route: {
			handler() {
				this.setTitle();
			},
			immediate: true,
		},
		routeTitle: {
			handler: 'setTitle',
		},
	},
	methods: {
		setTitle() {
			if (!this.routeTitle) {
				document.title = `${this.$route.meta.title} | Report Mule`;
				return;
			}
			document.title = `${this.routeTitle} | ${this.$route.meta.title} | Report Mule`;
		},
	},
};
</script>

<style lang="scss" scoped>
.toolbar {
	position: relative;
	&-title {
		position: relative;
	}
	&-image-container {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		overflow: hidden;
	}
	&-image {
		position: absolute;
		z-index: 0;
		width: 120%;
		height: 120%;
		top: -10%;
		left: -10%;
		background-size: cover;
		background-position: center center;
		filter: blur(8px);
	}
	&-additional {
		position: absolute;
		right: 0;
	}
}
</style>

<style lang="scss">
.toolbar-title {
	.route-archive-text {
		font-weight: 300;
		font-size: 70%;
		vertical-align: bottom;
	}
}
</style>
